var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 8,
    viewBox: "0 0 27 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.121271 8V0.727273H4.63121V1.67188H1.21857V3.88778H4.30806V4.82884H1.21857V8H0.121271ZM6.98065 8V0.727273H9.57298C10.1364 0.727273 10.604 0.824337 10.9757 1.01847C11.3497 1.21259 11.6291 1.4813 11.8137 1.82457C11.9984 2.16548 12.0907 2.55966 12.0907 3.0071C12.0907 3.45218 11.9972 3.84399 11.8102 4.18253C11.6255 4.5187 11.3462 4.7803 10.9721 4.96733C10.6004 5.15436 10.1329 5.24787 9.56942 5.24787H7.60565V4.30327H9.46999C9.82511 4.30327 10.1139 4.25237 10.3365 4.15057C10.5614 4.04877 10.7259 3.9008 10.8301 3.70668C10.9342 3.51255 10.9863 3.27936 10.9863 3.0071C10.9863 2.73248 10.9331 2.49455 10.8265 2.29332C10.7224 2.09209 10.5578 1.93821 10.3329 1.83168C10.1104 1.72277 9.818 1.66832 9.45579 1.66832H8.07795V8H6.98065ZM10.5708 4.71875L12.3677 8H11.1177L9.35636 4.71875H10.5708ZM14.426 8V0.727273H18.9856V1.67188H15.5233V3.88778H18.7477V4.82884H15.5233V7.0554H19.0282V8H14.426ZM21.4513 8V0.727273H26.011V1.67188H22.5487V3.88778H25.7731V4.82884H22.5487V7.0554H26.0536V8H21.4513Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/FREE.eeb88665ef8a36934ec2f661a5e59cc9.svg";
export { ForwardRef as ReactComponent };